/**
 * Trunnion AI - Socket.io Singleton Client
 */

import { io, Socket } from 'socket.io-client';
import { WS_URL } from '@/config/constants';

let socketInstance: Socket | null = null;

export function getSocketClient(token: string): Socket {
  if (socketInstance?.connected) {
    return socketInstance;
  }

  socketInstance = io(WS_URL, {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1_000,
    reconnectionDelayMax: 30_000,
    timeout: 10_000,
    autoConnect: true,
  });

  return socketInstance;
}

export function disconnectSocket(): void {
  if (socketInstance) {
    socketInstance.disconnect();
    socketInstance = null;
  }
}

export function getSocket(): Socket | null {
  return socketInstance;
}
